import { ImageLayoutTypes } from '../../../../nodes/Image/types';

export enum MediaBlockLayoutTypes {
  Center = 'Center',
  FullWidth = 'FullWidth',
  Break = 'Break',
  AddCaption = 'AddCaption',
  Frames = 'Frames',
}

export type PopoverMenuItem = {
  label: string;
  type: ImageLayoutTypes;
  Icon: any;
};

export { ImageLayoutTypes } from '../../../../nodes/Image/types';
